import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-299e4693"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]

import store from "@/store";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'koparkaWynikTable',
  props: {
  id: { type: Number, required: true },
  name: { type: String, required: true },
  link: { type: String, required: true },
  power: { type: Number, required: true },
  algorithm: { type: String, required: true },
  price: { type: Number, required: true },
  img: { type: String, required: true },
  hashrate: { type: Number, required: true },
  units: { type: String, required: true },
  revenue: { type: Number, required: true },
  profit: { type: Number, required: true },
  powerCost: { type: Number, required: true },
  daysToReachCost: { type: Number, required: true },
  heatProfit: { type: Number, required: true },
},
  setup(__props) {

const props = __props;

/* import { getAlgorithm } from "../tools/getAlgorithm"; */


const calculateDaysToReachCost = computed(() => {
  if (props.profit > 0) {
    return `Zwróci się w ${props.daysToReachCost} dni!`;
  } else {
    return `Nie zwróci się.`;
  }
});
const withHeat = computed(() => {
  return store.getters["miners/getMinersType"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass({
      'bg-green': __props.daysToReachCost <= 365,
      'bg-lightGreen': __props.daysToReachCost > 365 && __props.daysToReachCost <= 730,
      'bg-yellow': __props.daysToReachCost > 730 && __props.daysToReachCost <= 1095,
      'bg-orange': __props.daysToReachCost > 1095 && __props.daysToReachCost <= 1460,
      'bg-red': __props.daysToReachCost > 1460,
    })
  }, [
    _createElementVNode("td", null, _toDisplayString(__props.name), 1),
    _createElementVNode("td", null, _toDisplayString(__props.price) + "zł", 1),
    _createElementVNode("td", null, _toDisplayString(__props.revenue) + "zł", 1),
    _createElementVNode("td", null, _toDisplayString(__props.powerCost) + "zł", 1),
    (withHeat.value)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(__props.heatProfit), 1))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, _toDisplayString(__props.profit) + "zł", 1),
    _createElementVNode("td", null, _toDisplayString(calculateDaysToReachCost.value), 1),
    _createElementVNode("td", null, [
      _createElementVNode("a", {
        style: {"height":"20px","width":"20px","color":"black"},
        href: __props.link
      }, "Link", 8, _hoisted_2)
    ])
  ], 2))
}
}

})